import { StoreState } from '../types/store';

export const getOnboardingSlice = (state: StoreState) => state.onboarding;

export const getOnboardingIsShow = (state: StoreState) =>
    getOnboardingSlice(state).isShown;

export const getOnboardingCurrentState = (state: StoreState) =>
    getOnboardingSlice(state).currentState;

export const getRemoteOnBoardingState = (state: StoreState) =>
    getOnboardingSlice(state).remoteState;

export const getOnboardingStateStack = (state: StoreState) =>
    getOnboardingSlice(state).stateStack;
